import type { PropsWithChildren } from 'react'

import { cn } from '@morpho-org/ui-v6/utils'

type DivProps = React.HTMLAttributes<HTMLDivElement>

interface ContainerProps extends DivProps {
  selectable?: boolean
}

const Container = ({ selectable = true, className, ...props }: ContainerProps) => (
  <div
    className={cn(
      'bg-muted rounded-lg',
      selectable && 'hover:bg-accent hover:cursor-pointer',
      className
    )}
    {...props}
  />
)

const Header = ({ className, ...props }: DivProps) => (
  <div
    className={cn(
      'border-b-[0.5px] border-border flex w-full flex-row items-center justify-between py-xs px-sm',
      className
    )}
    {...props}
  />
)

const Row = ({ className, ...props }: DivProps) => (
  <div
    className={cn(
      'flex w-full flex-row items-center justify-between gap-sm py-xs px-sm',
      className
    )}
    {...props}
  />
)

export const StyledVaultPendingTimelock = {
  Container,
  Header,
  Row
}

export const HoverableStack = ({ className, ...props }: PropsWithChildren<DivProps>) => (
  <div
    className={cn(
      'cursor-pointer overflow-hidden rounded-lg py-2xs px-xs hover:bg-accent',
      className
    )}
    {...props}
  />
)
